/**
 * Returns the soil moisture percentage value for a site.
 *
 * The calculation finds the percentage of summary.latest_reading_date_rz1
 * within the range of the refill point to the full point.
 *
 * @param {object} summary
 * @returns {(number|null)}
 */
export const CalculateSiteSoilMoisture = (summary) => {
  return summary
    ? (summary.latest_reading_date_rz1 - summary.refill_point) /
        (summary.full_point - summary.refill_point)
    : null;
};

/**
 * Returns a number between 1 and 3
 *  - 1 = Green (Site summary is looking good)
 *  - 2 = Orange (Site summary warning)
 *  - 3 = Red (Site needs action)
 *
 * @param {object} summary
 * @returns {number}
 */
export const CalculateSiteSummaryLevel = (summary) => {
  let outsiteLimits = false;
  let outsiteStrategy = false;
  let aboveLimits = false;

  if (
    summary.latest_reading_date_rz1 > summary.full_point ||
    summary.latest_reading_date_rz1 < summary.refill_point
  ) {
    if (summary.latest_reading_date_rz1 > summary.full_point) {
      aboveLimits = true;
    }
    outsiteLimits = true;
  }

  if (
    summary.latest_reading_date_rz1 > summary.strategy_max ||
    summary.latest_reading_date_rz1 < summary.strategy_min
  )
    outsiteStrategy = true;

  return outsiteStrategy && outsiteLimits
    ? aboveLimits
      ? 4
      : 3
    : !outsiteStrategy && outsiteLimits
    ? 2
    : outsiteStrategy && !outsiteLimits
    ? 2
    : 1;
};

export const SummaryBootstrapColorClass = (siteResults) => {
  const summaryLevel = siteResults.alert_level;
  const fullPoint = siteResults.full_point;
  const latestReading = siteResults.latest_reading.rz1;
  if (summaryLevel === 3 && latestReading > fullPoint) {
    return 'primary';
  }

  return summaryLevel === 3
    ? 'danger'
    : summaryLevel === 2
    ? 'warning'
    : 'success';
};

export const SummaryBootstrapColorClassLevel = (level) => {
  return level === 4
    ? 'primary'
    : level === 3
    ? 'danger'
    : level === 2
    ? 'warning'
    : 'success';
};

export const AlertLevelLabel = (alertLevel) =>
  alertLevel === 4
    ? 'Above Full Point'
    : alertLevel === 3
    ? 'Attention Required'
    : alertLevel === 2
    ? 'Outside Strategy'
    : 'Within Strategy';

export const formatSiteType = (type) => {
  if (type === 'irrimax') {
    return 'IrriMAX Continuous';
  } else if (type === 'terraprobe') {
    return 'Weekly';
  } else {
    return type;
  }
};

export const openIrrimaxWindow = (url) => {
  window.open(url, '_blank', 'width=800,height=600').focus();
};

export const openIrrimaxTab = (url) => {
  window.open(url, '_blank').focus();
};

export const openIrrimaxCurrentTab = (url) => {
  window.open(url, '_self').focus();
};

